export interface User {
  id: string;
  email?: string | null;
  phone?: string | null;
  nickname?: string | null;
  timezone?: string | null;
  language?: string | null;
  created_at?: string;
}

export interface AuthResult {
  session_token: string;
  user: User;
  is_new_user?: boolean;
}

export interface OtpSendResult {
  expires_in: number;
}

export interface ApiErrorShape {
  code?: string;
  message?: string;
  detail?: string | { message?: string };
}

export class ApiError extends Error {
  readonly status: number;
  readonly code?: string;
  readonly payload?: unknown;

  constructor(message: string, status: number, code?: string, payload?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.payload = payload;
  }
}
